import apiService from "./apiService";
import AppConstants from "../appConstants";

class LanguageService {
    getAllLanguage(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_LANGUAGE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getLanguageDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_LANGUAGE}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerLanguage(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_LANGUAGE, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteLanguage(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_LANGUAGE}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_LANGUAGE_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    
    // =====================================================================
    
}

export default new LanguageService();
